const PRODUCTION_URL = "https://your-api.com/api/v1";
const STAGING_URL = "http://localhost:8080/api/v1";

const isStaging = process.env.NEXT_PUBLIC_ENV === "staging" || process.env.NEXT_PUBLIC_STAGING === "true";

export const SERVICE_URL = "https://rhuna-services-x4ige.ondigitalocean.app/api/v1"; //isStaging ? STAGING_URL : PRODUCTION_URL;

// Social authentication uses a different API endpoint
export const SOCIAL_SERVICE_URL = "https://rhuna-services-x4ige.ondigitalocean.app/api/v1/pulsar";
